export default __webpack_public_path__ + "static/media/93.2fa22925.jpg";